import { Pipe, PipeTransform } from '@angular/core';
import { User } from 'src/app/shared/models/security/user';

@Pipe({
	name: 'filterUserByProfile'
})
export class FilterUserByProfilePipe implements PipeTransform {
	transform(value: User[], filter: string[]): User[] {
		if (
			value === null ||
			filter === null ||
			filter.length === 0
		) {
			return value;
		}

		return value.filter((user) => {
			for (const profile of filter) {
				if (user.profile.name.toLowerCase().includes(profile.toLowerCase())) {
					return true;
				}
			}
			return false;
		});
	}
}
